import { useLocalSearchParams } from 'expo-router'

import { NotificationsGeneralScreen } from '@/src/features/settings/ui/screens/NotificationsGeneralScreen'

export default function () {
  const searchParams = useLocalSearchParams()
  return <NotificationsGeneralScreen searchParams={searchParams} />
}
